module.exports = __webpack_public_path__ + "img/spring_stretch.prt.1da26881.jpg";